export default "__VITE_ASSET__P_mdX3hF__"